import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class BaseProxyService {

    constructor(public _http: Http) {}

    get(url: string): Observable<any> {
		return this._http.get(url)
			.map((res: Response) => res.json())
			.catch(this.handleError);
	}
	
	 getOxi(url: string, headers: any): Observable<any> {
		return this._http.get(url, {
			headers: headers
		})
			.map((res: Response) => res.json())
			.catch(this.handleError);
	}

	post(url: string, params: any, headers: any): Observable<any> {
		return this._http.post(url, params, {
			headers: headers
		})
		.map((res: Response) => res.json())
		.catch(this.handleError);
	}
	
	postCallback(url: string, params: any, headers: any): Observable<any> {
		return this._http.post(url, params, {
			headers: headers
		})
		.map((res: Response) => res.json())
		.catch(this.handleError);
	}

	public handleError(error: any) {
		return Observable.throw(error);
	}

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/proxy/base-proxy.service.ts